import { BookingPlatform } from '$houdini';
import { supportedPlatform, type SupportedPlatform } from '@viamichelin/business';

export function getPlatform(): SupportedPlatform {
	return isSmallDevice()
		? supportedPlatform.WebMobile
		: isLargeDevice()
			? supportedPlatform.WebDesktop
			: supportedPlatform.WebTablet;
}

export function getBookingPlatform() {
	return isSmallDevice()
		? BookingPlatform.WEB_MOBILE
		: isLargeDevice()
			? BookingPlatform.WEB_DESKTOP
			: BookingPlatform.WEB_TABLET;
}

export function isSmallDevice(): boolean {
	if (typeof window === 'undefined') {
		return false; // Default to non-small device on server-side
	}
	return window.innerWidth <= 640; // TODO: vérifier avec l'équipe analytics et marketing
}

export function isLargeDevice(): boolean {
	if (typeof window === 'undefined') {
		return true; // Default to large device on server-side
	}
	return window.innerWidth > 1024; // TODO: vérifier avec l'équipe analytics et marketing
}
